import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Subscription, timer } from 'rxjs';
import { ApplicantsFacade } from '../../../../modules/admin-features/components/applicants/applicants.facade';
import { CountySelectionController } from '../../../county-selection/county-selection.controller';
import { CountyAddress } from '../../../county-selection/county-selection.machine';
export { County } from '../../../county-selection/county-selection.machine';

@Component({
  selector: 'app-boomer-county-fips-field',
  templateUrl: './boomer-county-fips-field.component.html',
  styleUrls: ['../boomer-text-input/boomer-text-input.component.scss'],
})
export class BoomerCountyFipsFieldComponent implements OnInit, OnChanges, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() zipCodeControl: AbstractControl;
  @Input() label = 'County';
  @Input() countyControlName = 'countyName';
  @Input() fipsControlName = 'fipsCode';
  @Input() savedAddress: CountyAddress;
  @Output() loadingChange = new EventEmitter<boolean>();
  @Output() zipErrorChange = new EventEmitter<string | null>();

  field: CountySelectionController;
  private subscription: Subscription;
  private pendingLoad: Subscription;

  constructor(private readonly applicantsFacade: ApplicantsFacade) {}

  ngOnInit(): void {
    this.field = new CountySelectionController(
      this.form,
      this.zipCodeControl,
      this.form.get(this.countyControlName),
      this.form.get(this.fipsControlName),
      this.form.get('state'),
      zip => this.applicantsFacade.getCountyByZipCode(zip),
    );
    this.subscription = this.field.state$.subscribe(() => {
      this.loadingChange.emit(this.field.loading);
      this.zipErrorChange.emit(this.field.error);
    });
    this.scheduleLoad();
  }

  private scheduleLoad(): void {
    this.pendingLoad?.unsubscribe();
    this.pendingLoad = timer(0).subscribe(() => this.field.load(this.savedAddress));
  }

  ngOnChanges(): void {
    if (this.field && this.savedAddress) this.scheduleLoad();
  }
  ngOnDestroy(): void {
    this.pendingLoad?.unsubscribe();
    this.subscription?.unsubscribe();
    this.field?.destroy();
  }
}
